import { ThemeContext } from './context/themeContext';
import Layout from '../src/pages/layout'
function App() {

  return (
    <ThemeContext>
      <Layout />
    </ThemeContext >);
}

export default App;
